<div class="filter-options">
  <div class="filters" [class.-active]="showFilter" (click)="showFilter = !showFilter; loadFilterOptions()">
    <span class="filter">{{ 'module.meterReading.filterDropDownText' | translate }}</span
    ><span class="fa fa-angle-down" aria-hidden="true"></span>
  </div>
  <div class="collapsible-part" *ngIf="showFilter" [ngStyle]="isInMeterWizard && { 'max-height': '400px', 'overflow-y': 'auto' }">
    <div *ngFor="let filter of energyTypesFilter">
      <span *ngIf="filter.isVisible">
        <div class="filter-header">
          <span>{{ filter.name }}</span>
          <mat-slide-toggle [color]="color" [checked]="filter.isOn()" (change)="toggleEnergyType($event, filter)"> </mat-slide-toggle>
        </div>
        <div *ngFor="let types of filter.energyTypes">
          <div class="filter-content" *ngIf="types.isVisible">
            <mat-checkbox [(ngModel)]="types.on" [labelPosition]="labelPosition" (change)="checkChanged(1)">
              <img src="./assets/icons/{{ types.icon }}" alt="energy-type-img" />
              {{ types.name }}
            </mat-checkbox>
          </div>
        </div>
      </span>
    </div>

    <div *ngFor="let filter of meterTypesFilter">
      <span *ngIf="filter.isVisible">
        <div class="filter-header">
          <span>{{ filter.name }}</span>
          <mat-slide-toggle [color]="color" [checked]="filter.isOn()" (change)="toggleMeterType($event, filter)"> </mat-slide-toggle>
        </div>
        <div *ngFor="let types of filter.meterTypes">
          <div class="filter-content" *ngIf="types.isVisible">
            <mat-checkbox [(ngModel)]="types.on" [labelPosition]="labelPosition" (change)="checkChanged(2)">
              <app-svg-icon class="filter-icon" src="./assets/icons/{{ types.icon }}"></app-svg-icon>
              {{ types.name }}
            </mat-checkbox>
          </div>
        </div>
      </span>
    </div>

    <span *ngIf="marketOperatorFilter[0].isVisible">
      <div class="iln-code-filter-section">
        <div class="filter-header">
          <span>{{ marketOperatorFilter[0].name }}</span>
          <mat-slide-toggle [color]="color" [checked]="marketOperatorFilter[0].isOn()" (change)="toggleMarketOperator($event, marketOperatorFilter[0])">
          </mat-slide-toggle>
        </div>
        <div *ngFor="let marketOperator of marketOperatorFilter[0].marketOperators">
          <div class="filter-content" *ngIf="marketOperator.isVisible">
            <mat-checkbox [(ngModel)]="marketOperator.on" [labelPosition]="labelPosition" (change)="checkChanged(3)"> </mat-checkbox>
            <div class="filter-name">{{ marketOperator.name }}</div>
          </div>
        </div>
      </div>
    </span>
  </div>
</div>
